import { Api } from 'src/api';
import { InterceptableAxiosRequestConfig } from 'src/api/Http/Http.types';
import { httpConfig } from 'src/lib/modules/http';
import {
  DraftDescriptionRequest,
  DraftDescriptionResponse,
} from 'src/lib/services/api/ai-agent-api/ai-agent.types';

const baseUrl = `${httpConfig.options.baseURL}/ai-agent`;

export const draftDescription = (
  data: DraftDescriptionRequest,
  config?: InterceptableAxiosRequestConfig,
): Promise<DraftDescriptionResponse> => {
  // `_noIntercept: true` silences the global error toast — HelpMeWritePanel
  // renders an inline message for 429/422/generic, and a double-toast on 429
  // would contradict the inline copy. Suppresses for all codes incl.
  // network errors; the inline generic-failure path covers them.
  const finalConfig: InterceptableAxiosRequestConfig = {
    ...(config ?? {}),
    _noIntercept: true,
  };
  return Api.http.post(`${baseUrl}/draft-description`, data, finalConfig);
};
